import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=07af079e&scoped=true&"
import script from "./my_center.js?vue&type=script&lang=js&"
export * from "./my_center.js?vue&type=script&lang=js&"
import style0 from "./my_center.scss?vue&type=style&index=0&id=07af079e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af079e",
  null
  
)

export default component.exports